import { render } from "./Tag_classification_management.vue?vue&type=template&id=6a4aa59a&scoped=true"
import script from "./Tag_classification_management.vue?vue&type=script&lang=js"
export * from "./Tag_classification_management.vue?vue&type=script&lang=js"

import "./Tag_classification_management.vue?vue&type=style&index=0&id=6a4aa59a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4aa59a"]])

export default __exports__